import React, { useState } from "react";
import {
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Card,
  Label,
  CardBody,
  Form,
} from "reactstrap";
import { useHistory } from "react-router-dom";

export const SearchCard = () => {
  const [focused, setFocused] = useState("");
  const [searchTxt, setSearchTxt] = useState("");
  const history = useHistory();

  const onFocus = () => setFocused("input-group-focus");
  const onBlur = () => setFocused("");
  const onEnter = (e: any) => {
    e.preventDefault();
    history.push(`/account/${searchTxt}`);
  };
  const onChange = (e: any) => {
    setSearchTxt(e.target.value);
  };

  return (
    <>
      <Card>
        <CardBody>
          <Label className="control-label">Search</Label>
          <Form onSubmitCapture={onEnter}>
            <InputGroup className={focused} onSubmit={onEnter}>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fas fa-search" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="text"
                placeholder="Search an address or delegate"
                name="search"
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={onChange}
              />
            </InputGroup>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};
